// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"ea8f04f1","239":"dac06248","389":"59ca09a1","453":"f88409ed","455":"7ac8d574","529":"47a444dc","651":"bf3c1632","692":"8fb00d57","821":"2b5cc8e9","959":"629377a1","977":"e9d662d1"}[chunkId] + ".chunk.js";
};